"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticatedEndpoint = exports.PublicEndpoint = exports.Endpoint = void 0;
// TODO For now, this assumes all endpoints use the POST method with a JSON-encoded request and response body.
class Endpoint {
    constructor(requestCodec, responseCodec) {
        this.requestCodec = requestCodec;
        this.responseCodec = responseCodec;
    }
}
exports.Endpoint = Endpoint;
Endpoint.public = (requestCodec, responseCodec) => {
    return new PublicEndpoint(requestCodec, responseCodec);
};
Endpoint.authenticated = (requestCodec, responseCodec, allowedRoles) => {
    return new AuthenticatedEndpoint(requestCodec, responseCodec, allowedRoles);
};
class PublicEndpoint extends Endpoint {
    constructor(requestCodec, responseCodec) {
        super(requestCodec, responseCodec);
    }
}
exports.PublicEndpoint = PublicEndpoint;
class AuthenticatedEndpoint extends Endpoint {
    constructor(requestCodec, responseCodec, allowedRoles) {
        super(requestCodec, responseCodec);
        this.allowedRoles = allowedRoles;
    }
}
exports.AuthenticatedEndpoint = AuthenticatedEndpoint;
//# sourceMappingURL=Endpoint.js.map